import { useMemo } from "react";
import { useLocation } from "react-router-dom";

import { DASHBOARD_KEYS, defaultSearchPath } from "../../../../globalConstants";
import { NavigationHistoryService } from "../../../services/navigation-history-service";

import GoBackButton from "./GoBackButton";

const CLIENT_DETAIL_ROUTE = /^\/client-detail\/[^/]+(?:\/|$)/;
const DASHBOARD_ROUTE = /^\/dashboard(?:\/|$)/;
function getClientSearchTarget(navigationHistory) {
  const savedSearch = localStorage.getItem("Search");
  return savedSearch || navigationHistory.get(DASHBOARD_KEYS.search) || defaultSearchPath;
}

/**
 * Uses in-app history first and falls back to the saved Client Search URL when opened directly.
 */
export default function AppBackButton({ containerClassName = "flex w-full justify-start" }) {
  const location = useLocation();
  const navigationHistory = useMemo(() => new NavigationHistoryService(), []);
  const pathname = location.pathname.replace(/\/+$/, "") || "/";
  const isClientDetailRoute = CLIENT_DETAIL_ROUTE.test(pathname);
  const isClientSearch = pathname === "/search";
  const isDashboard = DASHBOARD_ROUTE.test(pathname);

  if (isClientDetailRoute || isClientSearch || isDashboard) {
    return null;
  }

  const target = getClientSearchTarget(navigationHistory);

  return (
    <div className={containerClassName}>
      <GoBackButton id="app" prevUrlDefault={target} />
    </div>
  );
}
